import styled from "styled-components";
import { device } from "shared/styles/helpers"
import { IndentedMarginTopSmall, IndentedMarginTop } from "shared/styles/theme"


export const IndentedContainer = styled.div`
    margin: ${IndentedMarginTopSmall} 1rem 70px 1rem;
    @media ${device.laptop} {
        margin: ${IndentedMarginTop} 75px 70px 75px;
    }
    @media ${device.desktop} {
        margin: ${IndentedMarginTop} 115px 70px 115px;
    }

`